/**
 *   Created by FANGlh on 2018/11/8 14:57.
 *   *   创建投票
 */

import React, {Component} from 'react';
import './SendVote.css';
import {Select, Switch, Upload, Icon, Modal, TreeSelect, Button, Input} from 'antd';
import nextArrowimg from '../../../style/imgs/next_arrow.png';
import moment from 'moment'
import 'antd/dist/antd.css';
import SelectItem from './SelectItem';
import {Toast, Picker, List, DatePicker} from 'antd-mobile';
import TargetSelect from '../../../components/TargetSelect';
import {fetchPost, fetchGet, fetchGetNoSession} from '../../../utils/fetchRequest';
import {_baseURL, API} from '../../../configs/api.config';
import {getIntValue, getStrValue, isObjEmpty} from "../../../utils/common";
import UploadEnclosure from '../../../components/UploadEnclosure';
import {connect} from 'react-redux';
import {clearListState} from "../../../redux/actions/listState";


class SendVote extends Component {
    componentWillMount() {
        document.title = '发起投票'
    }

    componentDidMount() {
        this.getOrganization()
    }

    getOrganization = () => {
        Toast.loading('', 0)

        fetchGet(API.getClazzByTeacherId, {
            teacherId: this.props.userInfo.user.userFunId,
        }).then(response => {
            Toast.hide()
            const {targetData} = this.state
            targetData.length = 0
            if (response && response.data) {
                response.data.forEach((dataObj, data_index) => {
                    const stusDOSArray = dataObj.studentDOS
                    const teacherDOSArray = dataObj.teacherDOS

                    if (!isObjEmpty(teacherDOSArray)) {
                        const teacherData = []
                        teacherDOSArray.forEach((teacherObj, index) => {
                            if (teacherObj) {
                                teacherData.push({
                                    title: getStrValue(teacherObj, 'teacherName'),
                                    userId: getIntValue(teacherObj, 'teacherId'),
                                    userPhone: getStrValue(teacherObj, 'userPhone'),
                                    value: `0-${data_index}-${index}-` + getStrValue(teacherObj, 'teacherName'),
                                    key: `0-${data_index}-${index}`,
                                })
                            }
                        })

                        targetData.push({
                            title: dataObj.gradeName + dataObj.clazzName + '全体老师',
                            value: `0-${data_index}-` + dataObj.gradeName + dataObj.clazzName + '全体老师',
                            key: `0-${data_index}`,
                            children: teacherData,
                        })
                    }

                    if (!isObjEmpty(stusDOSArray)) {
                        const classData = []
                        stusDOSArray.forEach((stuObj, index) => {
                            if (stuObj) {
                                classData.push({
                                    title: getStrValue(stuObj, 'stuName'),
                                    userId: getIntValue(stuObj, 'stuId'),
                                    userPhone: getStrValue(stuObj, 'userPhone'),
                                    value: `2-${data_index}-${index}-` + getStrValue(stuObj, 'stuName'),
                                    key: `2-${data_index}-${index}`,
                                })
                            }
                        })

                        targetData.push({
                            title: dataObj.gradeName + dataObj.clazzName + '全体学生',
                            value: `2-${data_index}-` + dataObj.gradeName + dataObj.clazzName + '全体学生',
                            key: `2-${data_index}`,
                            children: classData,
                        })
                    }


                })
            }
            this.setState({
                targetData,
            })
        }).catch(error => {
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    constructor(props) {
        super(props);
        this.state = {
            voteTitle: null,
            endValue: null,
            voteType: null,
            nonameVote: false,
            voteOptionss: [null, null],
            targetList: [],
            targetCount: 0,
            targetData: [],
            previewVisible: false,
            previewImage: '',
            fileList: [],
            votePerson: [],
            voteMembers: 18,
            typeVote: [{
                label: '单选',
                value: '1'
            }, {
                label: '多选',
                value: '2'
            }]
        }
    }

    render() {

        //添加附件按钮
        const uploadButton = (
            <div>
                <Icon type="plus"/>
                <div className="ant-upload-text">Upload</div>
            </div>
        );
        const targetProps = {
            targetData: this.state.targetData,
            targetValues: this.state.targetList,
            title: '投票对象',
            targetCount: this.state.targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this)
        }

        const defaultTargetProps = {
            targetData: [],
            targetValues: this.state.targetList,
            title: '投票对象',
            targetCount: this.state.targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this)
        }
        return (

            <div onChange={this.handelValueCom} className='common-column-layout'>
                {this.state.targetData.length > 0 ? <TargetSelect {...targetProps}/>
                    : <TargetSelect {...defaultTargetProps}/>}
                <div className="comhline_sty"></div>
                <textarea autoFocus="autoFocus" ref='voteTitle' className="form-control textarea_sty"
                          rows="2" placeholder="请填写投票主题…" style={{resize: 'none'}}  maxLength={20}></textarea>
                <div className="comhline_sty"></div>

                <div>
                    {this.state.voteOptionss.map((itemata, index) => <SelectItem index={index} itemata={itemata}
                                                                                 handelSItem={this.handelSItem}
                                                                                 removeSItem={this.removeSItem}></SelectItem>)}
                    <div onClick={this.addSelectItem} className="text-center"
                         style={{color: "#0CE11D", fontSize: 12, margin: 10,}}>+ <span
                        style={{borderBottom: "1px #0CE11D solid"}}>添加选项</span></div>
                </div>

                <div className="comhline_sty"></div>

                <div className="common-column-layout">
                    <Picker
                        data={this.state.typeVote} title='投票类型' extra='请选择'
                        value={this.state.voteType}
                        onChange={this.handleSelectChange}
                        onOk={this.handleSelectChange} cols={1}>
                        <List.Item arrow="horizontal">投票类型</List.Item>
                    </Picker>
                    {/*<Select defaultValue="请选择" style={{ width:100 }} onChange={this.handleSelectChange}>*/}
                    {/*<Option value="1">单选</Option>*/}
                    {/*<Option value="2">多选</Option>*/}
                    {/*</Select>*/}
                    {/*<img src={nextArrowimg} className="nextarr_sty"/>*/}
                    <div className="comhline_sty1"></div>
                    <DatePicker
                        value={this.state.endValue}
                        locale={{
                            okText: '确定',
                            dismissText: '取消'
                        }}
                        onChange={date => this.setState({endValue: date})}>
                        <List.Item arrow="horizontal">结束时间</List.Item>
                    </DatePicker>
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div style={{width: 150, fontSize: 15, color: "#333333"}}>匿名投票:</div>
                    <div className="text-right" style={{width: "100%",}}>
                        <Switch checkedChildren="开" unCheckedChildren="关" defaultunchecked="false"
                                onChange={this.switchStatues}/>
                    </div>
                </div>
                <div className="comhline_sty1"></div>

                <UploadEnclosure
                    action={API.UPLOAD_FILE}
                    fileList={this.state.fileList}
                    count={9}
                    multiple={true}
                    beforeUpload={this.beforeUpload.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                />
                <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                        onClick={this.doSendVote}>提交</Button>
                {/*<center><Button type="button" className="btn btn-primary comBtn_sty"*/}
                {/*onClick={this.doSendVote}>提交</Button></center>*/}
            </div>
        )
    }

    onTargetFocus = (e) => {
        if (isObjEmpty(this.state.targetData)) {
            this.getOrganization()
        }
    }

    onTargetChange = (value, label, checkNodes, count) => {
        this.checkNodes = checkNodes
        this.setState({
            targetList: value,
            targetCount: count
        });
    }
    //发布提交
    doSendVote = (event) => {
        if (this.isRequesting == true) {
            return
        }

        const stuList = [], teacherList = []
        if (!isObjEmpty(this.checkNodes)) {
            this.checkNodes.forEach((node, index) => {
                if (node.value.startWith('0')) {
                    teacherList.push(node.userId)
                } else if (node.value.startWith('2')) {
                    stuList.push(node.userId)
                }
            })
        }
        console.log('state', this.state)

        if (stuList.length == 0 && teacherList.length == 0) {
            Toast.fail('请选择投票对象...')
            return
        }
        if (this.state.voteTitle == null || this.state.voteTitle.trim().length == 0) {
            Toast.fail('请填写投票主题...', 1)
            return
        }

        if (this.state.voteTitle.trim().length > 100) {
            Toast.fail('投票主题内容过长')
            return
        }

        for (let i = 0; i < this.state.voteOptionss.length; i++) {
            if (this.state.voteOptionss[i] == null || this.state.voteOptionss[i].trim().length == 0) {
                Toast.fail('存在选项内容为空...')
                return
            }

            if (this.state.voteOptionss[i].trim().length > 100) {
                Toast.fail('选项' + (i + 1) + '内容过长...')
                return
            }
        }

        if (this.state.voteType == null) {
            Toast.fail('请选择投票类型...')
            return
        }
        if (this.state.endValue == null) {
            Toast.fail('请选择正确结束时间...')
            return
        }

        var nowT = new Date().getTime()
        var endT = new Date(this.state.endValue).getTime()
        if (nowT > endT) {
            Toast.fail('当前时间不可大于结束时间', 1)
            return
        }

        var options = [] //组装投票选项List
        for (let i = 0; i < this.state.voteOptionss.length; i++) {
            const item = {
                optionName: this.state.voteOptionss[i],
                optionStatus: 1
            }
            options.push(item)
        }


        const approveFiles = []
        if (this.state.fileList) {
            this.state.fileList.forEach((value, index) => {
                approveFiles.push(value.picUrl)
            })
        }

        var params = {
            creator: this.props.userInfo.user.userFunId,
            voteStatus: 1,
            voteRemarks: this.props.userInfo.user.userName + "发起的投票",
            voteFile: JSON.stringify(approveFiles),
            stuIds: stuList,
            teacherIds: teacherList,
            voteEndDate: moment(this.state.endValue).format('YYYY-MM-DD HH:mm:ss'),
            voteType: 1,
            voteName: this.state.voteTitle,
            voteTopicDOS: [{
                topicName: this.state.voteTitle,
                topicStatus: 1,
                topicType: this.state.voteType[0],
                voteOptionsDOS: options,
            }]

        }
        console.log('params', {
            voteString: params
        })
        this.isRequesting = true
        Toast.loading('投票发布中...', 0)
        fetchPost(API.voteCreate, {
            voteString: JSON.stringify(params)
        }, {})
            .then((response) => {
                this.isRequesting = false
                Toast.hide()
                if (response.success) {
                    Toast.success('发布成功', 1)
                    this.isRequesting = true
                    clearListState()()
                    this.backTask = setTimeout(() => {
                        this.props.history.goBack()
                    }, 1000)
                }
            })
            .catch((error) => {
                Toast.hide()
                this.isRequesting = false
                if (typeof error === 'string') {
                    Toast.fail(error, 2)
                } else {
                    Toast.fail('请求异常', 2)
                }
            })
    }

    componentWillUnmount() {
        Toast.hide()
        clearTimeout(this.backTask)
    }

    removeSItem = (index) => {
        if (this.state.voteOptionss.length == 2) {
            return
        }
        let voteOptionss = this.state.voteOptionss
        voteOptionss.splice(index, 1)
        this.setState({
            voteOptionss
        })
    }
    handelSItem = (itemdata, index) => {
        console.log('index', index)
        console.log('itemdata', itemdata)
        let voteOptionss = this.state.voteOptionss
        voteOptionss[index] = itemdata
        this.setState({
            voteOptionss
        })
    }

    addSelectItem = (event) => {
        let voteOptionss = [...this.state.voteOptionss, null];
        this.setState({
            voteOptionss
        })
    }
    addAnnex = (event) => {
        console.log('addAnnex')
    }

    handleSelectChange = (value) => {
        console.log('voteType', value)
        this.setState({
            voteType: value
        })
    }
    handelValueCom = (event) => {
        //获取用户名的值
        let voteTitle = this.refs.voteTitle.value;
        //获得内容的值
        this.setState({
            voteTitle: voteTitle,
        })
    }

    switchStatues = (value) => {
        console.log('isOpend?', value)
        this.setState({
            nonameVote: value
        })
    }
    handleCancel = () => this.setState({previewVisible: false})

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }
    beforeUpload = (file, fileList) => {

    }
    handleChange = fileList => {
        if (fileList) {
            this.setState({fileList})
        }
    }

}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SendVote)